import gql from 'graphql-tag';

import { ApolloClient } from '../client';

const captureSignupGeolocationMutation = gql`
    mutation CaptureSignupGeolocation {
        captureSignupGeolocation {
            captured
            reason
        }
    }
`;

interface CaptureSignupGeolocationMutationResponse {
    __typename: 'Mutation';
    captureSignupGeolocation: {
        __typename: 'CaptureSignupGeolocationResult';
        captured: boolean;
        reason: string | null;
    };
}

/**
 * Fires the `captureSignupGeolocation` mutation. Fire-and-forget from the UI: a rejection
 * MUST never block onboarding — the caller is expected to wrap this in a try/catch.
 *
 * The backend handler is strongly idempotent (guards against repeat calls on retry) and
 * returns `{ captured: false, reason }` for soft failures (missing IP, IPRegistry hiccup,
 * already captured) rather than throwing.
 */
export async function captureSignupGeolocation(client: ApolloClient): Promise<void> {
    console.log('AppSync: capturing signup geolocation...');
    const response = await client.mutate<CaptureSignupGeolocationMutationResponse, {}>({
        mutation: captureSignupGeolocationMutation,
        variables: {},
    });
    const result = response.data?.captureSignupGeolocation;
    if (result && !result.captured) {
        console.warn('AppSync: captureSignupGeolocation soft-failed:', result.reason);
    }
}
